import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDpad = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 51,
	height: 51,
	viewBox: "0 0 51 51",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			opacity: .8,
			children: [/* @__PURE__ */ _jsx("circle", {
				cx: 25.5,
				cy: 25.5,
				r: 21.5,
				fill: "#2F2F2F",
				fillOpacity: .6,
				shapeRendering: "crispEdges"
			}), /* @__PURE__ */ _jsx("circle", {
				cx: 25.5,
				cy: 25.5,
				r: 21,
				stroke: "#A8A8A8",
				shapeRendering: "crispEdges",
				"data-role": "stroke-ring"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.3432 13.6246L25.9678 9L30.3033 13.3356",
			stroke: "#C8C8C8",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.6786 21L42.3032 25.6246L37.9677 29.9602",
			stroke: "#C8C8C8",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.3432 37.3355L25.9678 41.9601L30.3033 37.6246",
			stroke: "#C8C8C8",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9679 21L9.34326 25.6246L13.6788 29.9602",
			stroke: "#C8C8C8",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26 16L26 10",
			stroke: "#C8C8C8",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.3032 25.6568H41.3032",
			stroke: "#C8C8C8",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26 34.9602L26 40.9602",
			stroke: "#C8C8C8",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.3433 25.6568L10.3433 25.6568",
			stroke: "#C8C8C8",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 26,
			cy: 25,
			r: 4,
			stroke: "#C8C8C8",
			strokeWidth: 2,
			"data-role": "center-dot"
		})
	]
});
export default SvgDpad;
